var _ellipse, _ellipse2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 36,
    rx: 35.5,
    ry: 36,
    fill: "#64CD82",
    fillOpacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5018,
    cy: 35.9992,
    rx: 25.8182,
    ry: 26.1818,
    fill: "#64CD82",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_27493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7341 33.2744C30.5393 31.7213 26.5939 32.287 23.9467 34.9715C20.5896 38.3759 20.5896 43.9093 23.9467 47.3137C27.3038 50.7181 32.7604 50.7181 36.1175 47.3137C38.7647 44.6293 39.3225 40.6283 37.791 37.3885L42.2029 32.9144L46.2599 37.0285L50.3168 32.9144L46.2599 28.8004L48.2883 26.7433L44.2314 22.6292L33.7341 33.2744ZM32.0606 43.1996C30.9449 44.331 29.1193 44.331 28.0037 43.1996C26.888 42.0682 26.888 40.2169 28.0037 39.0855C29.1193 37.9542 30.9449 37.9542 32.0606 39.0855C33.1763 40.2169 33.1763 42.0682 32.0606 43.1996Z",
    fill: "#64CD82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_27493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6675,
    height: 34.6675,
    fill: "white",
    transform: "matrix(0.702145 -0.712034 0.702145 0.712034 10.7617 36)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shipping-icon.fc3edabc770ba9cb71c764fee07defa1.svg";
export { ForwardRef as ReactComponent };